<template>
  <b-modal ref="delete-sub-category" id="delete-sub-category" hide-footer hide-header centered>
    <h2 class="text-center mb-4">Törlés megerősítése</h2>
    <h5 class="text-center mb-4">Törölni kívánja a(z) {{ title }} alkategóriát?</h5>

    <div class="d-flex align-items-center justify-content-center">
      <b-button class="mr-2" @click="goBack">Vissza</b-button>
      <b-button class="ml-2" variant="primary" @click="confirmDelete">Megerősítés</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    _id: { type: String, required: true }
  },
  methods: {
    goBack() {
      this.$bvModal.hide('delete-sub-category')
    },
    confirmDelete() {
      this.$emit('delete-category', this._id)
      this.$bvModal.hide('delete-sub-category')
    }
  }
}
</script>

<style lang="scss" scoped></style>
